import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const FilterContent = styled.View`
  padding: ${RFValue(4)}px 0 0;
`;

export const FilterHeaderRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${RFValue(24)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const FilterSheetTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(17)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const FilterActiveBadge = styled.View`
  background-color: #15a118;
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(3)}px ${RFValue(10)}px;
`;

export const FilterActiveBadgeText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: #fff;
`;

export const FilterSection = styled.View`
  padding: 0 ${RFValue(24)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const FilterSectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: ${RFValue(12)}px;
`;

export const FilterChipsRow = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: ${RFValue(4)}px;
`;

interface FilterChipProps {
  active?: boolean;
}

export const FilterChip = styled.TouchableOpacity<FilterChipProps>`
  flex-direction: row;
  align-items: center;
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(9)}px ${RFValue(14)}px;
  background-color: ${({active, theme}) =>
    active ? '#15a118' : theme.colors.shape};
  border-width: 1.5px;
  border-color: ${({active}) => (active ? '#15a118' : 'rgba(0,0,0,0.07)')};
  margin-right: ${RFValue(8)}px;
  margin-bottom: ${RFValue(10)}px;
`;

export const FilterChipIcon = styled(MaterialCommunityIcons)<FilterChipProps>`
  font-size: ${RFValue(14)}px;
  color: ${({active}) => (active ? '#fff' : '#15a118')};
  margin-right: ${RFValue(5)}px;
`;

export const FilterChipText = styled.Text<FilterChipProps>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({active}) => (active ? '#fff' : '#444')};
`;

interface FilterCategoryChipProps {
  active?: boolean;
  isGold?: boolean;
}

export const FilterCategoryChip = styled.TouchableOpacity<FilterCategoryChipProps>`
  flex-direction: row;
  align-items: center;
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(9)}px ${RFValue(14)}px;
  background-color: ${({active, isGold}) => {
    if (active) { return isGold ? '#C8971B' : '#8A8A8A'; }
    return isGold ? 'rgba(200, 151, 27, 0.1)' : 'rgba(138, 138, 138, 0.1)';
  }};
  border-width: 1.5px;
  border-color: ${({active, isGold}) => {
    const color = isGold ? '#C8971B' : '#8A8A8A';
    return active ? color : isGold ? 'rgba(200, 151, 27, 0.3)' : 'rgba(138, 138, 138, 0.25)';
  }};
  margin-right: ${RFValue(8)}px;
  margin-bottom: ${RFValue(10)}px;
`;

export const FilterCategoryIcon = styled(MaterialCommunityIcons)<FilterCategoryChipProps>`
  font-size: ${RFValue(14)}px;
  color: ${({active, isGold}) =>
    active ? '#fff' : isGold ? '#C8971B' : '#8A8A8A'};
  margin-right: ${RFValue(5)}px;
`;

export const FilterCategoryText = styled.Text<FilterCategoryChipProps>`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({active, isGold}) => {
    if (active) { return '#fff'; }
    return isGold ? '#A87818' : '#666';
  }};
`;

export const FilterDivider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border2};
  margin: ${RFValue(16)}px ${RFValue(24)}px;
`;

export const FilterFooter = styled.View`
  flex-direction: row;
  gap: ${RFValue(10)}px;
  margin-top: ${RFValue(8)}px;
  padding: ${RFValue(16)}px ${RFValue(24)}px 0;
`;

export const FilterClearBtn = styled.TouchableOpacity`
  flex: 1;
  height: ${RFValue(46)}px;
  border-radius: ${RFValue(12)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border2};
  justify-content: center;
  align-items: center;
`;

export const FilterClearBtnText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text};
`;

export const FilterApplyBtn = styled.TouchableOpacity`
  flex: 2;
  height: ${RFValue(46)}px;
  border-radius: ${RFValue(12)}px;
  background-color: #15a118;
  justify-content: center;
  align-items: center;
`;

export const FilterApplyBtnText = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(13)}px;
  color: #fff;
`;
